(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var f = (window.SI && SI.moneyFormat) || '{{amount}} kr';
    var n = (cents / 100);
    var whole = Math.round(n * 100) % 100 === 0;
    function fmt(d, ts, ds) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return whole ? fmt(0, '.', ',') : fmt(2, '.', ',');
      if (k === 'amount_with_space_separator') return whole ? fmt(0, ' ', ',') : fmt(2, ' ', ',');
      return whole ? fmt(0, ',', '.') : fmt(2, ',', '.');
    });
  }

  /* paketprodukter (SI.packs): varukorgen innehåller alltid bara "1 påse" × antal påsar, så att kassan visar
     t.ex. "Spicy Cubes × 4". Paketpriset (2 = 399, 3 = 499 …) kommer från de automatiska rabatterna "Paketpris". */
  var PACKS = (window.SI && SI.packs) || {}, PACK_MAX = 12;
  function packsOf(cart, g) {
    var n = 0;
    cart.items.forEach(function (it) { var p = PACKS[it.variant_id]; if (p && p.g === g) n += p.n * it.quantity; });
    return n;
  }
  function unitOf(g) {
    return Object.keys(PACKS).filter(function (id) { return PACKS[id].g === g && PACKS[id].n === 1; })[0];
  }
  function wanted(g, n) {
    var up = {};
    Object.keys(PACKS).forEach(function (id) { if (PACKS[id].g === g) up[id] = 0; });
    up[unitOf(g)] = Math.min(Math.max(0, n), PACK_MAX);
    return up;
  }
  function setPacks(g, n) {
    return fetch(SI.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: wanted(g, Math.max(0, n)) }) })
      .then(function (r) { return r.json(); });
  }
  function normalize(cart) {
    var gs = [];
    cart.items.forEach(function (it) { var p = PACKS[it.variant_id]; if (p && gs.indexOf(p.g) < 0) gs.push(p.g); });
    return gs.reduce(function (pr, g) {
      return pr.then(function (c) {
        var want = wanted(g, packsOf(c, g)), have = {};
        c.items.forEach(function (it) { if (it.variant_id in want) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; });
        var ok = Object.keys(want).every(function (id) { return (have[id] || 0) === want[id]; }) &&
          c.items.filter(function (it) { return it.variant_id in want; }).length === Object.keys(want).filter(function (id) { return want[id] > 0; }).length;
        return ok ? c : setPacks(g, packsOf(c, g));
      });
    }, Promise.resolve(cart));
  }


  /* rotators (announcement, mini quotes) */
  $$('[data-rotate]').forEach(function (box) {
    var items = Array.prototype.slice.call(box.children);
    if (!items.length) return;
    var i = Math.max(0, items.findIndex(function (el) { return el.classList.contains('is-on'); }));
    items[i].classList.add('is-on');
    if (items.length < 2) return;
    var ms = +box.getAttribute('data-rotate') || 4000;
    setInterval(function () {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, ms);
  });

  /* mobile menu */
  var menu = $('[data-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.hidden = false; }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.hidden = true; }); });

  /* gallery */
  $$('[data-gal]').forEach(function (g) {
    var track = $('[data-gal-track]', g), ths = $$('[data-gal-go]', g);
    ths.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-gal-go');
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        ths.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      });
    });
  });

  /* dialogs */
  $$('[data-dialog-open]').forEach(function (b) {
    var d = document.getElementById(b.getAttribute('data-dialog-open'));
    if (!d) return;
    b.addEventListener('click', function () { d.showModal(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    $$('[data-dialog-close]', d).forEach(function (x) { x.addEventListener('click', function () { d.close(); }); });
  });

  /* tabs */
  $$('[data-tabs]').forEach(function (t) {
    var btns = $$('[data-tab]', t), panels = $$('[data-panel]', t);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-tab');
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== i; });
      });
    });
  });

  /* scroll to buy box */
  function toBuy(e) {
    var o = $('.offer');
    if (!o) return;
    if (e) e.preventDefault();
    window.scrollTo({ top: o.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }
  $$('[data-to-buy],[data-sticky-buy]').forEach(function (b) { b.addEventListener('click', toBuy); });

  /* product form */
  $$('[data-form]').forEach(function (form) {
    var atc = $('[data-atc]', form), label = $('[data-atc-label]', form);
    function selected() { return $('input[name="id"]:checked', form); }
    function update() {
      var r = selected(); if (!r) return;
      $$('.ocard', form).forEach(function (c) { c.classList.toggle('is-on', c.contains(r)); });
      label.textContent = SI.t.add + ' · ' + money(+r.getAttribute('data-price'));
    }
    $$('input[name="id"]', form).forEach(function (r) { r.addEventListener('change', update); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = selected(); if (!r) return;
      atc.disabled = true; label.textContent = SI.t.adding;
      fetch(SI.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [PACKS[r.value] ? { id: +unitOf(PACKS[r.value].g), quantity: PACKS[r.value].n } : { id: +r.value, quantity: 1 }] }) })
        .then(function (res) { return res.json(); })
        .then(function () { startTimer(); return refresh(true); })
        .catch(function () { form.submit(); })
        .finally(function () { atc.disabled = false; update(); });
    });
  });

  /* sticky bar */
  var sticky = $('[data-sticky]'), offer = $('.offer'), footer = $('.ftr');
  if (sticky && offer && 'IntersectionObserver' in window) {
    var offerVisible = true, footVisible = false, passed = false;
    function set() { sticky.hidden = offerVisible || footVisible || !passed; }
    new IntersectionObserver(function (en) {
      offerVisible = en[0].isIntersecting;
      passed = en[0].boundingClientRect.top < 0 || passed;
      set();
    }).observe(offer);
    if (footer) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; set(); }).observe(footer);
  }

  /* cart drawer */
  var drawer = $('#CartDrawer');
  function open() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  if (drawer) {
    $$('[data-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    $$('[data-cart-open]').forEach(function (a) {
      if (document.body.classList.contains('t-cart')) return;
      a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function render(cart) {
    $$('[data-count]').forEach(function (el) { el.textContent = cart.item_count; if (el.classList.contains('hdr__count')) el.hidden = cart.item_count === 0; });
    if (!drawer) return;
    var items = $('[data-items]', drawer), foot = $('[data-foot]', drawer), empty = $('[data-empty]', drawer), strip = $('[data-timer]', drawer);
    if (!cart.item_count) {
      items.innerHTML = ''; foot.hidden = true; empty.hidden = false; if (strip) strip.hidden = true; return;
    }
    foot.hidden = false; empty.hidden = true;
    var saved = 0, count = 0;
    /* paketprodukter visas som en rad: antal = påsar totalt, ingen paketetikett */
    var rows = [], groups = {};
    cart.items.forEach(function (it, idx) {
      var p = PACKS[it.variant_id], cap = compareMap[it.variant_id] || 0;
      var compare = cap > it.price ? cap * it.quantity : 0;
      if (it.original_line_price > it.final_line_price) compare = Math.max(compare, it.original_line_price);
      if (p) {
        var r = groups[p.g];
        if (!r) { r = groups[p.g] = { it: it, pack: p.g, qty: 0, price: 0, compare: 0 }; rows.push(r); }
        r.qty += p.n * it.quantity; r.price += it.final_line_price; r.compare += compare || it.final_line_price;
      } else {
        rows.push({ it: it, line: idx + 1, qty: it.quantity, price: it.final_line_price, compare: compare });
      }
    });
    items.innerHTML = rows.map(function (r) {
      var it = r.it, compare = r.compare > r.price ? r.compare : 0;
      if (compare) saved += compare - r.price;
      count += r.qty;
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variant = r.pack || it.product_has_only_default_variant ? '' : '<span class="line__v">' + esc(it.variant_title) + '</span>';
      var key = r.pack ? 'data-pack="' + r.pack + '"' : 'data-line="' + r.line + '"';
      return '<div class="line" ' + key + '>' +
        '<a class="line__img" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
        '<div class="line__mid"><a class="line__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-q="' + (r.qty - 1) + '" aria-label="Minska"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 12h14"/></svg></button><span>' + r.qty + '</span><button type="button" data-q="' + (r.qty + 1) + '" aria-label="Öka"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
        '<button type="button" class="line__rm" data-q="0">' + esc(SI.t.remove) + '</button></div>' +
        '<div class="line__p">' + (compare ? '<s>' + money(compare) + '</s>' : '') + '<b>' + money(r.price) + '</b></div></div>';
    }).join('');
    $$('[data-count]').forEach(function (el) { el.textContent = count; });
    var sr = $('[data-saverow]', drawer);
    sr.hidden = saved <= 0; $('[data-saved]', drawer).textContent = '−' + money(saved);
    $('[data-total]', drawer).textContent = money(cart.total_price);
    $$('[data-q]', items).forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.line'), q = +b.getAttribute('data-q');
        if (row.hasAttribute('data-pack')) {
          setPacks(row.getAttribute('data-pack'), q).then(loadCompare).then(render);
          return;
        }
        fetch(SI.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +row.getAttribute('data-line'), quantity: q }) })
          .then(function (r) { return r.json(); }).then(function (c) { render(c); });
      });
    });
    tick();
  }

  /* cart.js has no compare-at price, so read it from each product's .js once */
  var compareMap = {}, loaded = {};
  function loadCompare(cart) {
    var handles = cart.items.map(function (i) { return i.handle; }).filter(function (h, k, a) { return !loaded[h] && a.indexOf(h) === k; });
    return Promise.all(handles.map(function (h) {
      loaded[h] = true;
      return fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        p.variants.forEach(function (v) { compareMap[v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    })).then(function () { return cart; });
  }
  function refresh(show) {
    return fetch(SI.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(normalize).then(loadCompare).then(function (c) { render(c); if (show && drawer) open(); return c; });
  }

  /* varukorgssidan: samma paketlogik, sedan laddas sidan om */
  if (document.body.classList.contains('t-cart') && Object.keys(PACKS).length) {
    var getCart = function () { return fetch(SI.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
    $$('[data-pack-step]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var row = a.closest('[data-pack]'), qty = +row.getAttribute('data-qty'), k = a.getAttribute('data-pack-step');
        setPacks(row.getAttribute('data-pack'), k === 'rm' ? 0 : qty + (k === 'up' ? 1 : -1)).then(function () { location.reload(); });
      });
    });
    getCart().then(function (c) {
      var before = JSON.stringify(c.items.map(function (i) { return [i.variant_id, i.quantity]; }));
      return normalize(c).then(function (n) {
        if (JSON.stringify(n.items.map(function (i) { return [i.variant_id, i.quantity]; })) !== before) location.reload();
      });
    });
  }

  /* reservation timer: starts when something is added, not on page load */
  var KEY = 'si_timer_end';
  function startTimer() {
    var strip = drawer && $('[data-timer]', drawer); if (!strip) return;
    try { if (!sessionStorage.getItem(KEY)) sessionStorage.setItem(KEY, Date.now() + (+strip.getAttribute('data-min') || 10) * 60000); } catch (e) {}
  }
  var timerId;
  function tick() {
    var strip = drawer && $('[data-timer]', drawer); if (!strip) return;
    var end; try { end = +sessionStorage.getItem(KEY); } catch (e) {}
    if (!end) { strip.hidden = true; return; }
    strip.hidden = false;
    clearInterval(timerId);
    function draw() {
      var left = Math.max(0, end - Date.now()), m = Math.floor(left / 60000), s = Math.floor(left % 60000 / 1000);
      $('[data-clock]', strip).textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (!left) clearInterval(timerId);
    }
    draw(); timerId = setInterval(draw, 1000);
  }
})();
